import { useFormData } from 'hooks/useFormData';
import { useMultiFormView } from 'hooks/useMultiFormView';
import { useHistory } from 'react-router-dom';
import { useStorage } from './useStorage';
import { CREDIT_LIQUIDATION_ACTIONS } from '../constants/CreditLiquidationActions';
import {
	RESPONSE_PATH,
	RESPONSE_VIEW_DOCUMENT_BK_UPDATE_OK, RESPONSE_VIEW_ERROR,
} from '../constants/ResponseType';
import { DATA_LAYER_RESPONSE_KEY } from '../constants/DataLayers';
import { useRequestPrepaidServices } from './useRequestPrepaidService';

const convertToBase64 = async (file: File): Promise<string> => {
	try {
		const reader = new FileReader();
		const fileLoadPromise = new Promise<string>((resolve, reject) => {
			reader.onload = () => resolve(reader.result as string);
			reader.onerror = (error) => reject(error);
		});

		reader.readAsDataURL(file);
		return await fileLoadPromise;
	} catch (error) {
		throw new Error('Failed to convert file to base64');
	}
};

export const useCreditLiquidationFormContainerControl = () => {
	const { sendRequestPrepaid } = useRequestPrepaidServices();

	const {
		step,
		setStep,
		enableButton,
		setEnableButton,
		showLoadingModal,
		setShowLoadingModal,
		showLongModal,
	} = useMultiFormView();
	const history = useHistory();

	const CREDIT_LIQUIDATION_FORM_KEY = 'CREDIT_LIQUIDATION_FORM';
	const {setInitialVariablesForm } = useFormData();
	// const { createLoan, updateLoan, createRefinancingLoan } = useLoanServices(); Servicios De guardado
	const {saveInStorage, deleteItemFromStorage} = useStorage();


	const creditLiquidationExecuteActions: Record<CREDIT_LIQUIDATION_ACTIONS, Function> = {
		[CREDIT_LIQUIDATION_ACTIONS.BACK_STEP]: (_formData: any) => {
			setStep(step - 1);
		},
		[CREDIT_LIQUIDATION_ACTIONS.NEXT_STEP]: (formData: any) => {
			saveInStorage(CREDIT_LIQUIDATION_FORM_KEY, formData);
			setStep(step + 1);
		},
		[CREDIT_LIQUIDATION_ACTIONS.BACK_TO_HOME]: (_formData: any) => {
			window.location.href = `${process.env.REACT_APP_BK_URL} `;
		},
		[CREDIT_LIQUIDATION_ACTIONS.RESET_ID_STATUS_AND_BACK_STEP]: (_formData: any) => {
			deleteItemFromStorage(CREDIT_LIQUIDATION_FORM_KEY, 'id');
			deleteItemFromStorage(CREDIT_LIQUIDATION_FORM_KEY, 'version');
			setStep(step - 1);
		},
		[CREDIT_LIQUIDATION_ACTIONS.SAVE_FORM_IN_SERVICES]: async (formData: any) => {
			const { attachment, ...formDataWithoutAttachment } = formData;
			try {
				// Convert file to base64 and add it to form data
				const base64Data = await convertToBase64(attachment);
				const dataLocalStorage:any = sessionStorage.getItem('CREDIT_LIQUIDATION_FORM');
				const session:any = JSON.parse(dataLocalStorage);
				const requestPrepaidServices  = {
					firstname: session.firstName,
					lastname: session.lastName,
					rut: formatRUT(session.nationalId),
					renta: session.salary,
					phone: session.phone,
					email: session.email,
					base64: base64Data.toString(),
					fileName: `LiquidationPrepaidDocument${new Date().toISOString()}.${extractTypeFormat(base64Data.toString())}`,
					emailFinanciera: formData.emailInstitution,
					financiera: formData.financialInstitutionName,
					operacion: formData.numberOptions,
					rutFinanciera: formatRUT(formData.financialInstitutionRUT),
					patente: session.licensePlate,
					origen: 'MACFLY-FORMS',
				}
				const updatedFormData = {
					...formDataWithoutAttachment,
					base64: base64Data.toString(),
					fileName: `LiquidationPrepaidDocument${new Date().toISOString()}`
				};

				// Save updated form data
				saveInStorage(CREDIT_LIQUIDATION_FORM_KEY, updatedFormData);
				setInitialVariablesForm(updatedFormData);
				setShowLoadingModal(true);
				sendRequestPrepaid(requestPrepaidServices)
					.then((response) => {
						const { data } = response;
						sessionStorage.setItem('requestPrepaid', JSON.stringify(data));
						setShowLoadingModal(false);
						history.push(
							`${RESPONSE_PATH}/${RESPONSE_VIEW_DOCUMENT_BK_UPDATE_OK}/${DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_DOCUMENTOS_ENVIADOS}`
						);

					})
					.catch(() => {
						setShowLoadingModal(false);
						history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/error`);
					});
			} catch (error) {
				console.error('Error processing file:', error);
				setShowLoadingModal(false);
			}
		},
		[CREDIT_LIQUIDATION_ACTIONS.SAVE_FORM_IN_STORAGE]: (formData: any) => {
			saveInStorage(CREDIT_LIQUIDATION_FORM_KEY, formData);
			setStep(step + 1);
		},
		[CREDIT_LIQUIDATION_ACTIONS.UPDATE_FORM]: (formData: any) => {
			saveInStorage(CREDIT_LIQUIDATION_FORM_KEY, formData);
			setShowLoadingModal(true);
		}
	};

	const executeAction = (action: CREDIT_LIQUIDATION_ACTIONS, formData: any) => {
		creditLiquidationExecuteActions[action](formData);
	};

	return {
		executeAction,
		step,
		enableButton,
		setEnableButton,
		showLoadingModal,
		setShowLoadingModal,
		showLongModal,
	} as const;
};


const formatRUT = (data: any) => {
	const formatted = data.replace(/\./g, '');
	return formatted;
}

function extractTypeFormat(inputString: String) {
	const regex = /\/([^;]*);/;
	const match = inputString.match(regex);
	return match ? match[1] : null;
}